export const getWarehouses = (state) => state.warehouses
export const getScrollWarehouses= (state) => state.warehouseScroll
export const getScrollWarehousesMeta= (state) => state.warehouseScrollMeta
export const getScrollWarehousesCount = (state) => state.warehouseScrollCount
export const getUsersDoesNotHaveWarehouse = (state) => state.usersDoesNotHaveWarehouse
export const getStoreProducts = (state) => state.storeProducts